module.exports = __webpack_public_path__ + "static/media/bussola.aa98d262.gif";